var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { ref: "tableheader", staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.listQuery,
                    "label-width": "80px",
                    "label-position": _vm.labelPosition,
                  },
                },
                [
                  !_vm.collapse
                    ? _c(
                        "div",
                        { staticClass: "acea-row search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "活动名称：",
                                    "label-for": "activityId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        placeholder: "请选择活动",
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.listQuery.activityId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.listQuery,
                                            "activityId",
                                            $$v
                                          )
                                        },
                                        expression: "listQuery.activityId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.activityOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.activityName,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "商品名称：" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      placeholder: "请输入商品名称",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.listQuery.goods,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.listQuery, "goods", $$v)
                                      },
                                      expression: "listQuery.goods",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "销售类型：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择销售类型",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.listQuery.salesType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.listQuery,
                                            "salesType",
                                            $$v
                                          )
                                        },
                                        expression: "listQuery.salesType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "美食", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "文创", value: 1 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "游乐", value: 2 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "其他", value: 3 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleFilter },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch",
                                  attrs: { size: "small" },
                                  on: { click: _vm.resetFilter },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c("div", { staticClass: "acea-row row-between-wrapper mb15" }, [
            _c("div", { staticClass: "header-title" }, [_vm._v("报名列表")]),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _vm.checkPermi(["merchant:market_activity_apply:save"])
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v(" 添加报名 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-tabs",
            {
              staticClass: "mb15",
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "待审核", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "已通过", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "未通过", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "取消", name: "3" } }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "70", align: "right" },
              }),
              _c("el-table-column", {
                attrs: { label: "活动名称", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              trigger: "hover",
                              placement: "right",
                              "open-delay": 800,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text_overflow",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.activityName))]
                            ),
                            _c("div", { staticClass: "pup_card" }, [
                              _vm._v(_vm._s(scope.row.activityName)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "申请摊位数", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.hasDisplayValue(scope.row.needCount)
                                ? scope.row.needCount
                                : "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              trigger: "hover",
                              placement: "right",
                              "open-delay": 800,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text_overflow",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.goods))]
                            ),
                            _c("div", { staticClass: "pup_card" }, [
                              _vm._v(_vm._s(scope.row.goods)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品图片和摆台图", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview line-heightOne" },
                          [
                            _vm.getGoodsImages(scope.row.goodsImg).length > 0
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    "border-radius": "4px",
                                  },
                                  attrs: {
                                    src: _vm.getGoodsImages(
                                      scope.row.goodsImg
                                    )[0],
                                    "preview-src-list": _vm.getGoodsImages(
                                      scope.row.goodsImg
                                    ),
                                    fit: "cover",
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                      "border-radius": "4px",
                                      background: "#f5f7fa",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center",
                                      color: "#909399",
                                      "font-size": "12px",
                                    },
                                  },
                                  [_vm._v(" 无图片 ")]
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "姓名", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "手机号", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.hasDisplayValue(scope.row.phone)
                                ? scope.row.phone
                                : "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商户名称", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.merName) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "集市名称", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.marketName) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "销售类型", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getSalesTypeTagType(
                                scope.row.salesType
                              ),
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getSalesTypeText(scope.row.salesType)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTagType(scope.row.applyStatus),
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getStatusText(scope.row.applyStatus)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "履约保证金", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.hasDisplayValue(scope.row.performanceBond)
                                ? scope.row.performanceBond
                                : 0
                            ) +
                            "元 "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "履约保证金状态",
                  width: "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getPerformancePayStatusTagType(
                                scope.row
                              ),
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getPerformancePayStatusText(scope.row)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "报名时间", width: "150", prop: "updateTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "推广人", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.hasDisplayValue(scope.row.spreadUserNickName)
                                ? scope.row.spreadUserNickName
                                : "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "320", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 详情 ")]
                            ),
                            _vm.checkPermi([
                              "merchant:market_activity_apply:audit",
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAudit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 报名审核 ")]
                                )
                              : _vm._e(),
                            _vm.checkPermi([
                              "merchant:market_activity_apply:audit",
                            ]) && _vm.hasPromotionAudit(scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSpreadAudit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 推广审核 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acea-row row-center-wrapper mt15" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listQuery.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.listQuery.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "apply-detail-drawer",
          attrs: {
            title: "报名详情",
            visible: _vm.detailDrawer,
            direction: "rtl",
            size: "60%",
            "before-close": _vm.handleDetailClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDrawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "drawer-content",
            },
            [
              _vm.currentDetail
                ? _c(
                    "div",
                    { staticClass: "apply-detail" },
                    [
                      _vm.hasUserInfo
                        ? _c(
                            "el-descriptions",
                            {
                              attrs: {
                                title: "用户信息",
                                column: 2,
                                border: "",
                              },
                            },
                            [
                              _vm.hasDisplayValue(_vm.currentDetail.name)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "姓名" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.name) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canViewSensitiveUserInfo &&
                              _vm.hasDisplayValue(_vm.currentDetail.phone)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "手机号" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.phone) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canViewSensitiveUserInfo &&
                              _vm.hasDisplayValue(_vm.currentDetail.wechat)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "微信号" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.wechat) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canViewSensitiveUserInfo &&
                              _vm.hasDisplayValue(_vm.currentDetail.idCard)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "身份证" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.idCard) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canViewSensitiveUserInfo &&
                              _vm.idCardPhotos.length
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "身份证照片", span: 2 } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "image-list" },
                                        _vm._l(
                                          _vm.idCardPhotos,
                                          function (image, index) {
                                            return _c("el-image", {
                                              key: "id-card-" + index,
                                              staticClass: "wechat-image",
                                              staticStyle: {
                                                width: "200px !important",
                                                height: "200px !important",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: image,
                                                "preview-src-list":
                                                  _vm.idCardPhotos,
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canViewSensitiveUserInfo &&
                              _vm.hasDisplayValue(_vm.currentDetail.address)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "常住地址", span: 2 } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.address) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canViewSensitiveUserInfo &&
                              _vm.wechatPhotos.length
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "微信二维码", span: 2 } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "image-list" },
                                        _vm._l(
                                          _vm.wechatPhotos,
                                          function (image, index) {
                                            return _c("el-image", {
                                              key: "wechat-" + index,
                                              staticClass: "wechat-image",
                                              staticStyle: {
                                                width: "200px !important",
                                                height: "200px !important",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: image,
                                                "preview-src-list":
                                                  _vm.wechatPhotos,
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasApplyInfo
                        ? _c(
                            "el-descriptions",
                            {
                              attrs: {
                                title: "报名信息",
                                column: 2,
                                border: "",
                              },
                            },
                            [
                              _vm.hasDisplayValue(
                                _vm.currentDetail.activityName
                              )
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "活动名称" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentDetail.activityName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.needCount)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "申请摊位数" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.needCount) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.goods)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "商品名称" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.goods) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.salesType)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "销售类型" } },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.getSalesTypeTagType(
                                              _vm.currentDetail.salesType
                                            ),
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getSalesTypeText(
                                                  _vm.currentDetail.salesType
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.applyStatus)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "状态" } },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.getStatusTagType(
                                              _vm.currentDetail.applyStatus
                                            ),
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getStatusText(
                                                  _vm.currentDetail.applyStatus
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(
                                _vm.currentDetail.performanceBond
                              )
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "履约保证金" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentDetail.performanceBond
                                          ) +
                                          "元 "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(
                                _vm.currentDetail.performancePayStatus
                              ) || _vm.isPerformanceBondFree(_vm.currentDetail)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "履约保证金状态" } },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.getPerformancePayStatusTagType(
                                              _vm.currentDetail
                                            ),
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getPerformancePayStatusText(
                                                  _vm.currentDetail
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.auditRemark)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "审核备注", span: 2 } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentDetail.auditRemark
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.introduce)
                                ? _c(
                                    "el-descriptions-item",
                                    {
                                      attrs: {
                                        label: "一句话自我介绍",
                                        span: 2,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.introduce) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(
                                _vm.currentDetail.stallIntroduce
                              )
                                ? _c(
                                    "el-descriptions-item",
                                    {
                                      attrs: {
                                        label: "摊位名或品牌名",
                                        span: 2,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentDetail.stallIntroduce
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(
                                _vm.currentDetail.activityRecord
                              )
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "活动经历", span: 2 } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.currentDetail.activityRecord
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.deviceInfo)
                                ? _c(
                                    "el-descriptions-item",
                                    {
                                      attrs: { label: "用电设备描述", span: 2 },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.deviceInfo) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.maxKw)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "最大功率" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.maxKw) +
                                          "w "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.updateTime)
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "报名时间" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.updateTime) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasDisplayValue(_vm.currentDetail.remark)
                                ? _c(
                                    "el-descriptions-item",
                                    {
                                      attrs: {
                                        label: "备注（摊位信息）",
                                        span: 2,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.currentDetail.remark) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.businessFoodLicenseImages.length
                                ? _c(
                                    "el-descriptions-item",
                                    {
                                      attrs: {
                                        label: "营业执照或食品经营许可证",
                                        span: 2,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "image-list" },
                                        _vm._l(
                                          _vm.businessFoodLicenseImages,
                                          function (image, index) {
                                            return _c("el-image", {
                                              key: "license-" + index,
                                              staticStyle: {
                                                width: "120px",
                                                height: "120px",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: image,
                                                "preview-src-list":
                                                  _vm.businessFoodLicenseImages,
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.healthCertificateImages.length
                                ? _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "健康证", span: 2 } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "image-list" },
                                        _vm._l(
                                          _vm.healthCertificateImages,
                                          function (image, index) {
                                            return _c("el-image", {
                                              key: "health-" + index,
                                              staticStyle: {
                                                width: "120px",
                                                height: "120px",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: image,
                                                "preview-src-list":
                                                  _vm.healthCertificateImages,
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.getGoodsImages(_vm.currentDetail.goodsImg).length > 0
                        ? _c("div", { staticClass: "goods-image" }, [
                            _c("h4", [_vm._v("商品图片和摆台图")]),
                            _c(
                              "div",
                              { staticClass: "goods-images-list" },
                              _vm._l(
                                _vm.getGoodsImages(_vm.currentDetail.goodsImg),
                                function (image, index) {
                                  return _c("el-image", {
                                    key: index,
                                    staticStyle: {
                                      width: "150px",
                                      height: "150px",
                                      "border-radius": "4px",
                                      "margin-right": "10px",
                                      "margin-bottom": "10px",
                                    },
                                    attrs: {
                                      src: image,
                                      "preview-src-list": _vm.getGoodsImages(
                                        _vm.currentDetail.goodsImg
                                      ),
                                      fit: "cover",
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.hasSpreadInfo
                        ? _c(
                            "el-descriptions",
                            {
                              attrs: {
                                title: "推广信息",
                                column: 2,
                                border: "",
                              },
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "邀请人昵称" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail.inviterNickName
                                        )
                                          ? _vm.spreadDetail.inviterNickName
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "邀请人手机号" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail.inviterPhone
                                        )
                                          ? _vm.spreadDetail.inviterPhone
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "推广用户昵称" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail.spreadUserNickName
                                        )
                                          ? _vm.spreadDetail.spreadUserNickName
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "推广用户手机号" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail.spreadUserPhone
                                        )
                                          ? _vm.spreadDetail.spreadUserPhone
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "推广佣金" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "spread-highlight" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.hasDisplayValue(
                                              _vm.spreadDetail
                                                .marketActivitySpreadRecord
                                                .promotion
                                            )
                                              ? _vm.spreadDetail
                                                  .marketActivitySpreadRecord
                                                  .promotion
                                              : "无"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "审核状态" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "spread-highlight" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.hasDisplayValue(
                                              _vm.spreadDetail
                                                .marketActivitySpreadRecord
                                                .spreadStatus
                                            )
                                              ? _vm.getSpreadStatusText(
                                                  _vm.spreadDetail
                                                    .marketActivitySpreadRecord
                                                    .spreadStatus
                                                )
                                              : "无"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "创建时间" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail
                                            .marketActivitySpreadRecord
                                            .createTime
                                        )
                                          ? _vm.spreadDetail
                                              .marketActivitySpreadRecord
                                              .createTime
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "审核备注", span: 2 } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail
                                            .marketActivitySpreadRecord
                                            .spreadRemark
                                        )
                                          ? _vm.spreadDetail
                                              .marketActivitySpreadRecord
                                              .spreadRemark
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "推广审核附件", span: 2 } },
                                [
                                  _vm.spreadRemarkFiles.length
                                    ? _c(
                                        "div",
                                        { staticClass: "image-list" },
                                        _vm._l(
                                          _vm.spreadRemarkFiles,
                                          function (image, index) {
                                            return _c("el-image", {
                                              key: "spread-remark-" + index,
                                              staticStyle: {
                                                width: "120px",
                                                height: "120px",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: image,
                                                "preview-src-list":
                                                  _vm.spreadRemarkFiles,
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c("span", [_vm._v("无")]),
                                ]
                              ),
                              _c(
                                "el-descriptions-item",
                                { attrs: { label: "审核时间" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.hasDisplayValue(
                                          _vm.spreadDetail
                                            .marketActivitySpreadRecord
                                            .updateTime
                                        )
                                          ? _vm.spreadDetail
                                              .marketActivitySpreadRecord
                                              .updateTime
                                          : "无"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "detail-actions" },
                        [
                          _vm.checkPermi([
                            "platform:market_activity_apply:refund",
                          ]) && _vm.canRefundCurrentBond
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading:
                                      _vm.refundLoadingId ===
                                      _vm.currentDetail.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRefundPerformanceBond(
                                        _vm.currentDetail
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 退还履约保证金 ")]
                              )
                            : _vm._e(),
                          _vm.checkPermi([
                            "merchant:market_activity_apply:audit",
                          ])
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "warning" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAudit(_vm.currentDetail)
                                    },
                                  },
                                },
                                [_vm._v(" 报名审核 ")]
                              )
                            : _vm._e(),
                          _vm.checkPermi([
                            "merchant:market_activity_apply:audit",
                          ]) && _vm.hasPromotionAudit(_vm.currentDetail)
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "warning", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSpreadAudit(
                                        _vm.currentDetail
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 推广审核 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报名审核",
            visible: _vm.auditDialog,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.auditDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "auditForm",
              attrs: {
                model: _vm.auditForm,
                rules: _vm.auditRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核状态", prop: "applyStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.auditForm.applyStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.auditForm, "applyStatus", $$v)
                        },
                        expression: "auditForm.applyStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("已通过"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("未通过"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核备注", prop: "auditRemark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入审核备注",
                    },
                    model: {
                      value: _vm.auditForm.auditRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.auditForm, "auditRemark", $$v)
                      },
                      expression: "auditForm.auditRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelAudit } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitAudit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "推广审核",
            visible: _vm.spreadAuditDialog,
            width: "620px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.spreadAuditDialog = $event
            },
          },
        },
        [
          _vm.hasSpreadInfo
            ? _c(
                "div",
                { staticClass: "mb20" },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { title: "推广详情", column: 2, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "邀请人昵称" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.inviterNickName
                                )
                                  ? _vm.spreadDetail.inviterNickName
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "邀请人手机号" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.inviterPhone
                                )
                                  ? _vm.spreadDetail.inviterPhone
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "推广用户昵称" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.spreadUserNickName
                                )
                                  ? _vm.spreadDetail.spreadUserNickName
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "推广用户手机号" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.spreadUserPhone
                                )
                                  ? _vm.spreadDetail.spreadUserPhone
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "推广佣金" } },
                        [
                          _c("span", { staticClass: "spread-highlight" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.hasDisplayValue(
                                    _vm.spreadDetail.marketActivitySpreadRecord
                                      .promotion
                                  )
                                    ? _vm.spreadDetail
                                        .marketActivitySpreadRecord.promotion
                                    : "无"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "当前审核状态" } },
                        [
                          _c("span", { staticClass: "spread-highlight" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.hasDisplayValue(
                                    _vm.spreadDetail.marketActivitySpreadRecord
                                      .spreadStatus
                                  )
                                    ? _vm.getSpreadStatusText(
                                        _vm.spreadDetail
                                          .marketActivitySpreadRecord
                                          .spreadStatus
                                      )
                                    : "无"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.marketActivitySpreadRecord
                                    .createTime
                                )
                                  ? _vm.spreadDetail.marketActivitySpreadRecord
                                      .createTime
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "更新时间" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.marketActivitySpreadRecord
                                    .updateTime
                                )
                                  ? _vm.spreadDetail.marketActivitySpreadRecord
                                      .updateTime
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "当前审核备注", span: 2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasDisplayValue(
                                  _vm.spreadDetail.marketActivitySpreadRecord
                                    .spreadRemark
                                )
                                  ? _vm.spreadDetail.marketActivitySpreadRecord
                                      .spreadRemark
                                  : "无"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "当前审核推广附件", span: 2 } },
                        [
                          _vm.spreadRemarkFiles.length
                            ? _c(
                                "div",
                                { staticClass: "image-list" },
                                _vm._l(
                                  _vm.spreadRemarkFiles,
                                  function (image, index) {
                                    return _c("el-image", {
                                      key: "spread-detail-file-" + index,
                                      staticStyle: {
                                        width: "100px",
                                        height: "100px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src: image,
                                        "preview-src-list":
                                          _vm.spreadRemarkFiles,
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _c("span", [_vm._v("无")]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "spreadAuditForm",
              attrs: {
                model: _vm.spreadAuditForm,
                rules: _vm.spreadAuditRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核状态", prop: "spreadStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.spreadAuditForm.spreadStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.spreadAuditForm, "spreadStatus", $$v)
                        },
                        expression: "spreadAuditForm.spreadStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("通过（已奖励）"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("已失效"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.shouldShowSpreadAuditExtraFields
                ? _c(
                    "el-form-item",
                    { attrs: { label: "推广审核备注", prop: "spreadRemark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入推广审核备注",
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.spreadAuditForm.spreadRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.spreadAuditForm, "spreadRemark", $$v)
                          },
                          expression: "spreadAuditForm.spreadRemark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.shouldShowSpreadAuditExtraFields
                ? _c(
                    "el-form-item",
                    { attrs: { label: "推广审核附件", prop: "remarkFile" } },
                    [
                      _c("div", { staticClass: "image-upload-container" }, [
                        _c(
                          "div",
                          { staticClass: "image-list" },
                          [
                            _vm._l(
                              _vm.spreadRemarkFileList,
                              function (image, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "spread-file-" + index,
                                    staticClass: "image-item",
                                  },
                                  [
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "100px",
                                        height: "100px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src: image,
                                        "preview-src-list":
                                          _vm.spreadRemarkFileList,
                                        fit: "cover",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "image-actions" },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            icon: "el-icon-delete",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeSpreadRemarkFile(
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm.spreadRemarkFileList.length < 9
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "image-upload-btn",
                                    on: { click: _vm.openSpreadRemarkUpload },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-plus" }),
                                    _c("div", { staticClass: "upload-text" }, [
                                      _vm._v("选择图片"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c("div", { staticClass: "upload-tip" }, [
                          _vm._v("支持jpg、png格式，最多上传9张图片"),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelSpreadAudit } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmitSpreadAudit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }